import { jsx as _jsx } from "react/jsx-runtime";
import "../style/controls/headlineBeforeSection.scss";
const CLASS_NAME = "customize-control-headline-before-section";
const HeadlineBeforeSection = (param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: CLASS_NAME,
        children: children
    });
};
export { HeadlineBeforeSection };
